import { useCallback, useState, useEffect } from 'react'

const useOnScreen = ({
  root = null,
  rootMargin = '0px',
  threshold = 0,
} = {}) => {
  const [observer, setObserver] = useState(null)

  const [isIntersecting, setIntersecting] = useState(false)

  const measureRef = useCallback(
    (node) => {
      if (node) {
        const newObserver = new IntersectionObserver(
          ([entry]) => {
            setIntersecting(entry.isIntersecting)
          },
          { root, rootMargin, threshold },
        )

        newObserver.observe(node)
        setObserver(newObserver)
      }
    },
    [root, rootMargin, threshold],
  )

  useEffect(() => {
    return () => {
      if (observer) {
        observer.disconnect()
      }
    }
  }, [observer])

  return { measureRef, isIntersecting, observer }
}

export default useOnScreen
